
import React from "react";
import { Button } from "@/components/ui/button";
import { History, Pencil, Save, X, Loader2 } from "lucide-react";

interface NotificationActionsProps {
  editMode: boolean;
  showEditHistory: boolean;
  setEditMode: (editMode: boolean) => void;
  setShowEditHistory: (show: boolean) => void;
  resetNotification: () => void;
  isPending: boolean;
  handleSubmit: (e: React.FormEvent) => void;
}

const NotificationActions = ({
  editMode,
  showEditHistory,
  setEditMode,
  setShowEditHistory,
  resetNotification,
  isPending,
  handleSubmit
}: NotificationActionsProps) => {
  if (!editMode) {
    return (
      <div className="flex gap-2">
        <Button 
          type="button"
          variant="outline"
          size="sm"
          onClick={() => setShowEditHistory(!showEditHistory)}
        >
          <History className="mr-2 h-4 w-4" />
          {showEditHistory ? "Verberg geschiedenis" : "Toon geschiedenis"}
        </Button>
        <Button 
          type="button" 
          variant="outline" 
          onClick={() => setEditMode(true)}
        >
          <Pencil className="mr-2 h-4 w-4" />
          Bewerken
        </Button>
      </div>
    );
  }
  
  return (
    <div className="flex gap-2">
      <Button 
        type="button" 
        variant="outline" 
        onClick={() => {
          setEditMode(false);
          resetNotification();
        }}
      >
        <X className="mr-2 h-4 w-4" />
        Annuleren
      </Button>
      <Button 
        type="button" 
        onClick={handleSubmit} 
        disabled={isPending}
      >
        {isPending ? (
          <>
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            Opslaan...
          </>
        ) : (
          <>
            <Save className="mr-2 h-4 w-4" />
            Opslaan
          </>
        )}
      </Button>
    </div>
  );
};

export default NotificationActions;
